export const SITE_URL = 'https://lenvol.festicsn.com';
export const SITE_NAME = "L'envol digital pour Elles";

/** Construit un noeud BreadcrumbList schema.org à partir d'une liste [{ name, path }]. */
export function breadcrumbJsonLd(items) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: item.name,
      item: item.path ? `${SITE_URL}${item.path}` : undefined,
    })),
  };
}
